import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import PageContainer from '../PageContainer';
import Button from '../Button';
import useMessageService from '../../services/i18n/useMessageService';

const propTypes = {
    captchaWidget: PropTypes.node,
    error: PropTypes.bool,
    onCancel: PropTypes.func,
    show: PropTypes.bool,
};

const CaptchaVerificationPage = ({ show, captchaWidget, onCancel, error }) => {
    const [[verifyCaptchaPagePrompt, cancelLabel, errorContent, backLabel]] = useMessageService([
        'captcha.verification_page_content',
        'general.cancel',
        'captcha.error_content',
        'general.back',
    ]);

    return (
        <div hidden={!show}>
            <PageContainer>
                <div
                    css={css`
                        max-width: 35rem;
                    `}
                >
                    <p
                        css={css`
                            font-size: 1.5rem;
                            margin: 0;
                            margin-bottom: 3.3333rem;
                        `}
                    >
                        {error ? errorContent : verifyCaptchaPagePrompt}
                    </p>
                    <div
                        hidden={error}
                        css={css`
                            width: 100%;
                            margin-bottom: 1.6667rem;
                        `}
                    >
                        {captchaWidget}
                    </div>
                    <Button
                        onClick={onCancel}
                        variant="ghost"
                        css={({ blueDefault }) => css`
                            color: ${blueDefault};
                            font-size: 1.3333rem;
                            height: 3.3333rem;

                            &:not([disabled]):hover,
                            &:not([disabled]):focus,
                            &:not([disabled]):active {
                                color: ${blueDefault};
                            }
                        `}
                    >
                        {error ? backLabel : cancelLabel}
                    </Button>
                </div>
            </PageContainer>
        </div>
    );
};

CaptchaVerificationPage.propTypes = propTypes;

export default CaptchaVerificationPage;
